import {TextField, TextFieldProps} from "@mui/material";
import React from "react";

export type ActivityKindSelectProps = Omit<TextFieldProps, "onChange"> & {
    onChange?: (value: string) => void
}

const options: ({label: string, value: string})[] = [
    {
        label: "Не выбран",
        value: "",
    },
    {
        label: "55 Деятельность пограничных и таможенных органов",
        value: "55",
    },
    {
        label: "56 Деятельность федеральных органов исполнительной власти",
        value: "56"
    },
    {
        label: "57 Строительство, реконструкция, техническое оснащение",
        value: "57"
    },
    {
        label: "58 Эксплуатация и техническое обслуживание",
        value: "58"
    },
    {
        label: "59 Деятельность морского и внутреннего водного транспорта",
        value: "59"
    },
    {
        label: "60 Деятельность по предоставлению услуг связи",
        value: "60"
    },
    {
        label: "61 Деятельность по предоставлению банковских услуг",
        value: "61",
    },
    {
        label: "62 Медико-санитарная помощь",
        value: "62",
    },
    {
        label: "63 Деятельность по хранению товаров на складах",
        value: "63",
    },
    {
        label: "64 Эксплуатация и техническое обслуживание дезинфекционно-промывочного блока",
        value: "64",
    },
    {
        label: "65 Деятельность, связанная с проведением дезинфекции",
        value: "65",
    },
    {
        label: "66 Транспортирование по трубопроводам",
        value: "66",
    },
    {
        label: "67 Ремонт и техническое обслуживание судов",
        value: "67",
    },
    {
        label: "68 Обеспечение работоспособности котельных, тепловых и электрических сетей",
        value: "68",
    },
    {
        label: "69 Уборка территории и служебных помещений",
        value: "69",
    },
    {
        label: "70 Осуществление государственного портового контроля",
        value: "70",
    },
    {
        label: "71 Деятельность консульских пунктов МИДа России",
        value: "71",
    },
    {
        label: "72 Деятельность по проведению геодезических измерений",
        value: "72",
    },
    {
        label: "73 Розничная торговля",
        value: "73",
    },
    {
        label: "74 Обеспечению безопасности и охраны",
        value: "74",
    },
]


export const ActivityKindSelect = (props: ActivityKindSelectProps) => {
    const {onChange, ...other} = props;

    const handleChange = (e) => {
        onChange && onChange(e.target.value);
    }

    return (
        <TextField
            {...other as any}
            select
            SelectProps={{native: true}}
            onChange={handleChange}
        >
            {options.map(option => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </TextField>
    )
}